/* eslint-disable spaced-comment */
import callAPISagas from './callAPI/sagas';
import { all, fork } from 'redux-saga/effects';
import LayoutSaga from './layouts/saga';
// import paginationSaga from './paginationStore/saga';

export default function* rootSaga() {
    yield all([callAPISagas(), fork(LayoutSaga)]); //, fork(paginationSaga)
}
